import { createRouter, createWebHistory } from 'vue-router';

import Home from '../views/Home.vue';
import Entreprises from '../views/Entreprises.vue';
import Particuliers from '../views/Particuliers.vue';
import FineArt from '../views/FineArt.vue';
import Contact from '../views/Contact.vue';

const routes = [
  { path: '/', name: 'Home', component: Home },
  { path: '/entreprises', name: 'Entreprises', component: Entreprises },
  { path: '/particuliers', name: 'Particuliers', component: Particuliers },
  { path: '/fine-art', name: 'FineArt', component: FineArt },
  { path: '/contact', name: 'Contact', component: Contact }
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior() {
    return { top: 0 };
  }
});

export default router;
